import * as React from 'react';
import { FaPlay } from 'react-icons/fa';
import { Button, ButtonProps } from './Button'


export const PlayButton = (props: ButtonProps) => {
    return(
        <Button 
            style={{
                backgroundColor: 'white',
                color: "#111219"
            }}
            horizontalOnly
            title="play"
            icon={<FaPlay color={"#111219"} />}
           {...props} 
        />
    )
}